import * as React from 'react';
import { SearchWidget } from './SearchWidget';

export interface ControlledSearchWidgetProps {
  searchChanged: (search: string | null) => any;
  focusOnMount?: boolean;
  loading?: boolean;
  inputRef?: React.RefObject<HTMLInputElement>;
  className?: any;
}

export interface ControlledSearchWidgetState {
  value: string | null;
}

export class ControlledSearchWidget extends React.Component<ControlledSearchWidgetProps, ControlledSearchWidgetState> {
  constructor(props: ControlledSearchWidgetProps) {
    super(props);
    this.state = {
      value: null
    };
  }

  render() {
    return (
      <SearchWidget
        {...this.props}
        search={this.state.value}
        searchChanged={(search) => {
          this.setState(
            {
              value: search
            },
            () => {
              this.props.searchChanged(search);
            }
          );
        }}
      />
    );
  }
}
